import { CohortStepType } from 'src/types/cohorts';

export type StepConfig = Record<
  CohortStepType,
  {
    title: string;
    statusText: string;
    order: number;
    showActionButtons?: boolean;
    showCreateCohortButton?: boolean;
    enableRetryPreviousStep?: boolean;
  }
>;

export const STEP_CONFIG: StepConfig = {
  [CohortStepType.QueryValidation]: {
    title: 'Step 1: Query validation',
    statusText: 'Validating your query...',
    order: 0,
    showActionButtons: true,
  },
  [CohortStepType.DataExtraction]: {
    title: 'Step 2: Data extraction',
    statusText: 'Extracting relevant data...',
    order: 1,
    showActionButtons: true,
    enableRetryPreviousStep: true,
  },
  [CohortStepType.CodesSelection]: {
    title: 'Step 3: Codes selection',
    statusText: 'Identifying concept codes...',
    order: 2,
    showCreateCohortButton: true,
  },
  [CohortStepType.Results]: {
    title: 'Step 4: Result',
    statusText: 'Finalizing the results...',
    order: 3,
  },
};
